import { Container, Paper, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const CheckoutError = () => {
  const { t } = useTranslation()

  return (
    <Container component="main" maxWidth="md" sx={{ mt: 10, mb: 10 }}>
      <Paper square={true} sx={{ width: "100%", borderRadius: 5 }}>
        <Stack alignContent="center" alignItems="center" sx={{ p: 5 }}>
          <Typography data-cy="productNotFound" data-testid="product-not-found">
            {t("postPurchase.productNotFound")}
          </Typography>
        </Stack>
      </Paper>
    </Container>
  )
}

export default CheckoutError
